import * as React from 'react';
import { NavbarBrand } from 'reactstrap';
import { Image, Nav } from 'react-bootstrap/';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ModalComponent from '../Modals/Modal';
import ModalCallbackComponent from '../Modals/Callback/ModalCallbackComponent';
import ModalSalesComponent from '../Modals/SalesModal/ModalSalesComponent';
import ModalPolicyComponent from '../Modals/PolicyModal/ModalPolicyComponent';
import TopNavItem from './TopNavItem';
import { DASHBOARD, EMERGENCY_ASSISTANCE, WHATS_NEW, SHOPPING_CART, CLAIMS, WHATSAPP_LIVE_CHAT, MESSAGES, ADDCOVER, BANKING_DETAILS, CALL_ME_BACK, FNOL } from '../../routes/routes';
import './NavMenu.css';
import { navigateTo } from '../../actions/navigationActions';
import { showCallMeModal, showAddNewItem, showInEditScreen, showQuoteEditScreen, showInEditRemoveScreen, showClickawayFollowUp } from '../../actions/modalActions';
import { isLocalhost } from '../../App';
import { addProduct } from '../../actions/salesActions';
//@ts-ignore
import animationData from './kp-logo-animation-14340-v1.1.json';
import Lottie from 'react-lottie';
import { NAM_COUNTRY_ID_NUMBER } from '../../constants/internationalization';

class NavMenu extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            render: true,
        };
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleClicked = this.handleClicked.bind(this);
        this.handleNewItem = this.handleNewItem.bind(this);
    }

    addProduct() {
        this.props.dispatchShowAddNewItem();
    }

    handleClicked(destination: string) {
        if (!this.props.profile.isLinked && (destination === CLAIMS || destination === EMERGENCY_ASSISTANCE || destination == FNOL)) {
            // do nothing
        }
        else if (destination === MESSAGES) {
            if (this.props.profile.countryId === 157) {
                this.props.handleCallMeBack();
            }
            else {
                window.open(WHATSAPP_LIVE_CHAT, '_blank');
            }
        }
        else {
            this.handleRedirect(destination);
        }
    }

    handleNewItem() {
        this.props.dispatchShowAddNewItem()
    }

    handleRedirect(destination) {

        if (destination === CALL_ME_BACK && this.props.sales.isInEdit) {
            this.props.showInEditScreen("", CALL_ME_BACK);
        } else if (this.props.sales.isQuoteScreen) {
            this.props.dispatchShowQuoteEditScreen(this.props.sales.quoteScreenRiskId, destination);
        } else if (destination === CALL_ME_BACK && !this.props.sales.isInEdit) {
            this.props.handleCallMeBack();
        } else if (destination === ADDCOVER && !this.props.sales.isInEdit && !this.props.sales.isInRemove && !this.props.claimSubmit.followUp) {
            this.addProduct()
        }
        else if (destination === ADDCOVER && this.props.sales.isInEdit) {
            this.props.showInEditScreen("", ADDCOVER);
        }
        else if (destination === ADDCOVER && this.props.sales.isInRemove) {
            this.props.showInEditScreen("", ADDCOVER);
        }
        else if (this.props.claimSubmit.followUp) {
            this.props.dispatchAction(showClickawayFollowUp("", destination));
        }

        else {
            this.props.handleNavigateTo(destination);
        }
    }

    public render() {
        if (this.props.static === true) {
            return (
                <Nav id="topNav" className="justify-content-center navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow" activeKey="">
                    <div className="kp-top-nav col-12 text-center">
                        <Nav.Item>
                            <NavbarBrand>
                                <Image src="./Images/logo-kingprice.svg" fluid />
                            </NavbarBrand>
                        </Nav.Item>
                    </div>
                </Nav>
            );
        }

        const defaultOptions = {
            loop: false,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            },
        };
        const { firebaseAuth,auth } = this.props;
        const isLoggedIn = firebaseAuth.uid && auth.provider != "anonredirect";
        let topMenu;
        let whatsNew = "./images/icon-what-s-new.svg";
        let menuLabelHome = "Home";
        let menuLabelWhatsApp = "WhatsApp";
        let menuLabelCallMeBack = "Call me back";
        let menuLabelAddCover = "Add cover";
        let menuLabelClaims = "Claims";
        let menuLabelEmergencyAssist = "Emergency assist";
        let menuLabelRoadsideAssist = "Roadside assist";
        let menuLabelEmergencyAssistMobile = "Emergency";
        let menuLabelRoadsideAssistMobile = "Roadside";

        if (isLoggedIn) {
            topMenu =
                <Nav id="topNav" className={this.props.fullscreen.loadingScreenVisible ? "justify-content-center navbar-expand-md navbar-toggleable-md nav ssp-topnav-loadingscreen-active ssp-topnav-loggedin" : "justify-content-center navbar-expand-md navbar-toggleable-md nav ssp-topnav-loadingscreen-not-active ssp-topnav-loggedin"} activeKey={DASHBOARD}>
                    <div className="container-fluid">
                        <div id="topNavMainDiv" className="row">
                            <div id="topNavHomeDiv" className="col-12 col-md-3 mt-md-1 text-center text-md-left kp-top-nav ssp-topnav-loggedin">
                                <Nav.Item>
                                    <NavbarBrand tag={Link} to={"#"} onClick={() => this.handleRedirect(DASHBOARD)}>
                                        {/* In case logo needs static revert: 
                                         <Image src="./Images/logo-kingprice.svg" fluid />
                                         */}
                                        <div className="lottie-kp-logo-container" title="King Price">
                                            {!this.props.fullscreen.loadingScreenVisible &&
                                                <>
                                                    <Lottie className="lottie-kp-logo" options={defaultOptions}
                                                        width={170}
                                                        height={49}
                                                        isStopped={false}
                                                        isPaused={false}
                                                        speed={1.1}
                                                    />
                                                </>
                                            }
                                        </div>
                                    </NavbarBrand>
                                </Nav.Item>
                            </div>

                            <div id="topNavCenterDiv" className="col-12 col-md-6 text-center">
                                <div className={!this.props.fullscreen.loadingScreenVisible ? "ssp-topnav-items-flex-container ssp-topnav-animate-on animate-topnav-comein" : "ssp-topnav-items-flex-container ssp-topnav-animate-off"}>
                                    <TopNavItem navIconName={menuLabelHome} alt={menuLabelHome} title={menuLabelHome} cssClass={'top-nav-item-center ssp-topnav-home ' + this.props.navigation.homeLine} handleOnClick={() => this.handleClicked(DASHBOARD)} />
                                    {this.props.profile.countryId === 244 &&
                                        <TopNavItem navIconName={menuLabelWhatsApp} alt="WhatsApp" title="WhatsApp" handleOnClick={() => this.handleClicked(MESSAGES)} cssClass={'top-nav-item-center ssp-topnav-whatsapp ' + this.props.navigation.messagesLine} />
                                    }
                                    {this.props.profile.countryId != 244 &&
                                        <TopNavItem navIconName={menuLabelCallMeBack} alt="Call me Back" title="Call me Back" handleOnClick={() => this.handleClicked(MESSAGES)} cssClass={'ssp-topnav-callmeback ' + this.props.navigation.messagesLine} />
                                    }
                                    <TopNavItem navIconName={menuLabelAddCover} alt={menuLabelAddCover} title={menuLabelAddCover} handleOnClick={() => this.handleRedirect(ADDCOVER)} cssClass="ssp-topnav-addcover" />
                                    <TopNavItem navIconName={menuLabelClaims} alt={menuLabelClaims} title={menuLabelClaims} handleOnClick={() => this.handleClicked(FNOL)} cssClass={this.props.profile.isLinked ? "isLinked ssp-topnav-claims " + this.props.navigation.claimsLine : "ssp-topnav-claims top-nav-item-center isGuest"} />
                                    <TopNavItem navIconName={this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? menuLabelEmergencyAssist : menuLabelRoadsideAssist} navIconNameMobileOnly={this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? menuLabelEmergencyAssistMobile : menuLabelRoadsideAssistMobile} alt={this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? menuLabelEmergencyAssist : menuLabelRoadsideAssist} title={this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? menuLabelEmergencyAssist : menuLabelRoadsideAssist} handleOnClick={() => this.handleClicked(EMERGENCY_ASSISTANCE)} cssClass={this.props.profile.isLinked ? "top-nav-item-center isLinked ssp-topnav-emergency-assist " + this.props.navigation.emergencyAssistLine : " top-nav-item-center ssp-topnav-emergency-assist isGuest"} />
                                </div>
                            </div>
                            <div id="topNavRightDiv">
                                <TopNavItem image={whatsNew} href={WHATS_NEW} target="_blank" alt="What's new" tooltip="What's new" cssClass="d-none" />
                                <TopNavItem handleOnClick={() => this.handleRedirect(CALL_ME_BACK)} alt="Call me back" tooltip="Call me back" cssClass={this.props.profile.countryId === 244 ? "ssp-topnav-call-me-back" : "ssp-topnav-call-me-back invisible"} />
                                {this.props.cart.quoteId !== "" && this.props.cart.products?.length >= 0 &&
                                    <TopNavItem handleOnClick={() => this.handleRedirect(BANKING_DETAILS)} alt="Shopping Cart" tooltip="Cart" cssClass="ssp-topnav-add-to-cart" count={this.props.cart.products.length} />
                                }
                                {this.props.cart.quoteId === "" &&
                                    <TopNavItem handleOnClick={this.handleNewItem} alt="Shopping Cart" tooltip="Cart" cssClass="ssp-topnav-add-to-cart" />
                                }
                            </div>
                        </div>
                    </div>
                </Nav>
        } else {
            topMenu =
                <>
                    <Nav id="topNav" className="justify-content-center navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow" activeKey="">
                        <div className="kp-top-nav col-12 text-center">
                            <Nav.Item>
                                <NavbarBrand tag={Link} to={DASHBOARD}>
                                    <Image src="./Images/logo-kingprice.svg" fluid />
                                </NavbarBrand>
                            </Nav.Item>
                        </div>
                    </Nav>
                </>
        }
        return (
            <>
                {topMenu}
                <ModalComponent />
                <ModalCallbackComponent />
                <ModalSalesComponent />
                <ModalPolicyComponent />
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    if (isLocalhost) {
        console.log(state);
    }

    return {
        auth: state.auth,
        firebaseAuth: state.firebase.auth,
        firebase: state.firebase,
        profile: state.profile,
        navigation: state.navigation,
        cart: state.cart,
        sales: state.sales,
        fullscreen: state.fullscreen,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAddProduct: (action) => dispatch(addProduct(action)),
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
        handleNavigateTo: (destination) => dispatch(navigateTo(destination)),
        dispatchShowAddNewItem: () => dispatch(showAddNewItem()),
        showInEditScreen: (id, destination) => dispatch(showInEditScreen(id, destination)),
        dispatchShowQuoteEditScreen: (id, destination) => dispatch(showQuoteEditScreen(id, destination)),
        dispatchShowInEditRemoveScreen: (id, destination) => dispatch(showInEditRemoveScreen(id, destination)),
        dispatchAction: (e) => dispatch(e),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(NavMenu)